import { render, staticRenderFns } from "./VideoWorkout.vue?vue&type=template&id=29bf5146&"
import script from "./VideoWorkout.vue?vue&type=script&lang=js&"
export * from "./VideoWorkout.vue?vue&type=script&lang=js&"
import style0 from "./VideoWorkout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports